// Console-side adapters for the `@formant/chat` tool-render seams (S4,
// DEV-16991). The package is host-agnostic: memory cards live HERE and flow into
// the package through the `renderToolCall` seam. Fleet-viz now lives in the
// package itself (rendered natively via `detectFleetData`), so it no longer
// needs a seam here. Incidents live in the package (UI) fed by the console
// incidents adapter (data) — see incidents-adapter.ts.
// See packages/chat/docs/host-injection-seams.md.
import type { IToolRenderSeams } from '@formant/chat';

import { parseSaveMemoryCall, SaveMemoryToolCard } from '../persistent-agents/chat/AgentMemoryCard';

/**
 * `renderToolCall` seam — claims `save_memory` calls and renders the console's
 * bespoke memory card; returns null for every other tool so the call falls
 * through to the package's default row.
 */
export const renderMemoryToolCall: IToolRenderSeams['renderToolCall'] = (call) => {
  const save = parseSaveMemoryCall(call);
  if (save) return <SaveMemoryToolCard {...save} />;
  return null;
};

/**
 * The console's full seam set, for surfaces that embed the package's
 * `AgentChat` directly (the /agents thread page + orchestration-graph
 * sidebar) rather than through `PaChatView`'s props. Wrap the transcript in
 * `<ToolRenderProvider value={consoleToolRenderSeams}>` so memory cards render
 * there exactly as they do on /chat. Module-level const so the context value is
 * referentially stable.
 */
export const consoleToolRenderSeams: IToolRenderSeams = {
  renderToolCall: renderMemoryToolCall,
};
